import './routes';
import './stylesheets/jobDetailsWidget.styl';
import './stylesheets/taskStatusView.styl';
import './JobStatus';



// WEBPACK FOOTER //
// ./~/@girder/worker/main.js